import { createContext } from "react";

// True inside the new full-width top fold. For the new variant both folds can be on the
// page at once (see overviewLayout.module.scss), so a component shared by them (PropertyTopSection
// → PropertyDetailsSection) takes its layout from the fold it sits in, not from the variant.
const OverviewFoldContext = createContext(false);

export default OverviewFoldContext;
